import { SET_TIME_ZONE, SET_TIME_ZONE_IS_INITED } from './timeZoneConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setInitialTimeZone = (newTimeZone) => ({
  type: SET_TIME_ZONE,
  payload: newTimeZone,
})
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setTimeZoneIsInited = (newStatus) => ({
  type: SET_TIME_ZONE_IS_INITED,
  payload: newStatus,
})
